import { Link } from "react-router-dom";
import { ShieldCheck, Lightning, Browser, Heart } from "@phosphor-icons/react";

const POINTS = [
  {
    icon: Lightning,
    title: "Instant & local",
    body: "Every tool runs entirely in your browser. No servers, no queues — results appear as you type.",
  },
  {
    icon: ShieldCheck,
    title: "Private by design",
    body: "Your text, URLs and passwords never leave your device. Nothing is stored or transmitted.",
  },
  {
    icon: Browser,
    title: "No sign-up, ever",
    body: "No accounts, paywalls or usage caps. Open a tool and get to work immediately.",
  },
  {
    icon: Heart,
    title: "Built for makers",
    body: "Developers, marketers and writers get a tight, keyboard-friendly workbench with zero clutter.",
  },
];

export default function About() {
  return (
    <div className="mx-auto max-w-4xl px-5 sm:px-8 py-20">
      <p className="text-xs font-bold uppercase tracking-[0.15em] text-primary">
        About Expert Technologies
      </p>
      <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">
        A sharper set of everyday web tools.
      </h1>
      <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground">
        Expert Technologies is a curated collection of free online utilities for SEO, text
        processing and the web. We obsess over speed and clarity: no bloated
        ads, no dark patterns, no account walls — just tools that do one job
        exceptionally well.
      </p>

      <div className="mt-12 grid grid-cols-1 border-l border-t border-border/70 sm:grid-cols-2">
        {POINTS.map((p) => {
          const Icon = p.icon;
          return (
            <div
              key={p.title}
              className="border-b border-r border-border/70 bg-card p-7"
            >
              <span className="grid h-11 w-11 place-items-center border border-border text-primary">
                <Icon size={22} weight="duotone" />
              </span>
              <h3 className="mt-5 font-display text-lg font-bold tracking-tight">
                {p.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {p.body}
              </p>
            </div>
          );
        })}
      </div>

      <div className="mt-12 border border-border bg-card p-8">
        <h2 className="font-display text-2xl font-bold tracking-tight">
          Ready to build something?
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Jump into the full toolbox and pick what you need.
        </p>
        <Link
          to="/"
          data-testid="about-cta"
          className="mt-5 inline-flex items-center gap-2 bg-primary px-5 py-3 text-xs font-bold uppercase tracking-[0.12em] text-primary-foreground transition-transform duration-150 hover:-translate-y-0.5 active:scale-[0.98]"
        >
          Browse all tools
        </Link>
      </div>
    </div>
  );
}
